import { Component, OnInit, Injector }  from '@angular/core';
import ZimbraInstance                             from '../../models/ZimbraInstance';
import ZimbraInstanceSearch                       from '../../models/ZimbraInstanceSearch';
import { LoggedBaseComponent }       from '../../_components/LoggedBaseComponent';
import { ZimbraInstanceService }                                      from '../../_service/zimbrainstance.service';

@Component({
  selector: 'app-zimbrainstance-create-edit',
  templateUrl: './zimbrainstance-create-edit.component.html',
  styleUrls: ['./zimbrainstance-create-edit.component.css']
})
export class ZimbraInstanceCreateEditComponent extends LoggedBaseComponent implements OnInit {

  zimbrainstance            : ZimbraInstance        = new ZimbraInstance();
  zimbrainstance_search     : ZimbraInstanceSearch  = new ZimbraInstanceSearch();

  constructor(
    injector                    : Injector,
    private _zimbraInstanceService : ZimbraInstanceService
  )
  {
    super(injector);
  }

  ngOnInit() 
  {
    this.getZimbraInstance();
  }

  getZimbraInstance()
  {
    //If im editing a ZmInstance, an ID is passed from URL
    const id = +this._route.snapshot.paramMap.get('id');
    if (id > 0)
    {
      // this.in_update = true;
      this._zimbraInstanceService.getZimbraInstance(id)
        .subscribe(data => {
          this.zimbrainstance        = new ZimbraInstance(data["retdata"]["data"]);
        },
        err => {
            this._interfaceService.openSimpleErrorSnackBar(err);
        });
    }
  }

  save()
  {
   
      if (this.zimbrainstance.id !== null && this.zimbrainstance.id !== undefined)
      {
        this._zimbraInstanceService.updateZimbraInstance(this.zimbrainstance).subscribe(
          data => {
            var res                 = data["retdata"]["data"];
            this._interfaceService.openSimpleInfoSnackBar(this._translateService.instant(res));
            this._router.navigate(['/dashboard/admin/zimbrainstance']);
          },
          err => {
            this._interfaceService.openSimpleErrorSnackBar(this._translateService.instant("errors.something_went_wrong"));
        });
      }
      else
      {
        this._zimbraInstanceService.saveZimbraInstance(this.zimbrainstance).subscribe(
          data => {
            var res                 = data["retdata"]["data"];
            this._interfaceService.openSimpleInfoSnackBar(this._translateService.instant(res));
            this._router.navigate(['/dashboard/admin/zimbrainstance']);
          },
          err => {
            this._interfaceService.openSimpleErrorSnackBar(this._translateService.instant("errors.something_went_wrong"));
        });
      }

    
    
  }

}
